export default{
    urla: "http://175.24.249.4:8081",
}